import { AxiosResponse } from 'axios'
import { axiosApi, defaultItemPerPage } from './base.api'
import {
  InventoryCheckWaste,
  InventoryCheckWastePagination,
  ReusedResourcePagination,
  ApiInventoryCheckWaste
} from '../models/inventoryChecks.model'
import { PaginationParams } from '../models/commons.models'

export namespace InventoryCheckApi {
  export interface GetListParams extends PaginationParams {
    search?: string
    catalog: string
  }

  export const createWaste = async (wasteData: ApiInventoryCheckWaste): Promise<InventoryCheckWaste> => {
    const response: AxiosResponse<InventoryCheckWaste> = await axiosApi.post('/inventoryChecks/wastes', wasteData)
    return response.data
  }

  export const getListWastes = async (params: GetListParams): Promise<InventoryCheckWastePagination> => {
    const response: AxiosResponse<InventoryCheckWastePagination> = await axiosApi.get('/inventoryChecks/wastes', {
      params: {
        disablePaginate: false,
        itemsPerPage: defaultItemPerPage,
        page: 0,
        ...params,
      }
    })
    return response.data
  }

  export const updateWaste = async (id: string, update: ApiInventoryCheckWaste): Promise<InventoryCheckWaste> => {
    const response: AxiosResponse<InventoryCheckWaste> = await axiosApi.patch(`/inventoryChecks/wastes/${id}`, update)
    return response.data
  }

  export const deleteWaste = async (id: string): Promise<void> => {
    await axiosApi.delete(`/inventoryChecks/wastes/${id}`)
  }

  export const getListReusedResources = async (params?: GetListParams): Promise<ReusedResourcePagination> => {
    const response: AxiosResponse<ReusedResourcePagination> = await axiosApi.get('/inventoryChecks/resources', {
      params: {
        disablePaginate: true,
        ...params,
      },
    })
    return response.data
  }
}